import { commonComponentIcons, navbarIcons } from 'helpers/images';
import { useOnOutsideClick } from 'hooks/useOutsideClick';
import React, { useState } from 'react';
import { history } from "helpers";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'service/utilities';
import classess from './styles.module.scss';
import { getName } from 'redux/action/login';

const Navbar = ({ handleToggle }) => {
  const [toggle, setToggle] = useState(false);
  const { innerBorderRef } = useOnOutsideClick(() => setToggle(false));
  const name = useSelector((state) => state?.login?.name);
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(getName({}))
    logout();
  }



  const navigate_dashboard=()=>{

    history.push({
pathname: '/dashBoard',
    })
  }
  return (
    <div className={`${classess.navbar} px-4 py-3`}>
      <div className='d-flex justify-content-between w-100 h-100'>
        <div onClick={handleToggle}>
          <img
            src={navbarIcons.logo}
            className={`${classess.thangamayilNavLogo} img-fluid`}
            alt='logo'
            onClick={navigate_dashboard}
          />
        </div>
        <div className='d-flex justify-content-end w-100 align-items-center'>
          <div
            className='d-flex justify-content-end align-items-center cursor-pointer'
           
          >
            <div className="pe-3">
              <img src={commonComponentIcons.bell} alt="bell" />
            </div>
            <div>
              <p
                className={`${classess.profileNameLabel} fs-14 fw-700  m-0 pe-3`}
              >
                {name}
              </p>
            </div>
            <div>
              <img
                src={navbarIcons.profileLogo}
                className={`${classess.profileNavLogo} img-fluid`}
                alt='profile'
                onClick={() => setToggle(true)}
              />
            </div>
          </div>
        </div>
        {toggle && (
          <div
            className={`${classess.navbarDropDownContainer}`}
            ref={innerBorderRef}
          >
            <div className='d-flex flex-row' onClick={handleLogout}>
              <div className='pe-3'>
                <p className='mb-0'>Logout</p>
              </div>
              <div>
                <img
                  src={commonComponentIcons.logout}
                  className={classess.logoutIcon}
                  alt='logout'
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
